import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const BusinessImpactBanner = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: "#FFF5F5",
        borderRadius: "8px",
        border: "1px solid #FFE0E0",
        px: 3.5,
        py: 2,
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Header with Icon and Title */}
      <Grid2 container alignItems="center" gap={1} sx={{ mb: 2 }}>
        <LightbulbIcon sx={{ fontSize: 20, color: "#FF6B6B" }} />
        <Typography variant="fw600s24cB50500"
          sx={{ lineHeight: "24px", }}>
          Business Impact
        </Typography>
      </Grid2>

      {/* Key-Value Pairs */}
      <Grid2 container gap={20} sx={{ pl: 1 }}>
        {data.map((item, index) => (
          <Grid2 key={index} container gap={1} flexDirection={"column"}>
            <Typography variant="fw400s14c494949" sx={{ lineHeight: "20px" }}>
              {item.label}:
            </Typography>
            <Typography variant="fw500s16c000000" sx={{ lineHeight: "20px" }}>
              {item.value}
            </Typography>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default BusinessImpactBanner;
